module.exports = __webpack_public_path__ + "img/procreate-desktop_cn.4e541f8.jpg";